import Config from 'utils/packages/configs';
const TU_DISPUTE_URL_PROD = 'https://www.callcreditreport.co.uk/dispute/OpenV2';
const TU_DISPUTE_URL_STAGING = 'https://ct.callcreditreport.co.uk/dispute/OpenV2';
export const DisputeTypeEnum = {
    accounts: 'FinancialAccountInformation',
    cifasCases: 'Moda',
    addressLinks: 'AddressLink',
    otherNames: 'AliasLink',
    financialConnections: 'AssociateLink',
    searches: 'SearchHistory',
    judgments: 'CCJ',
    electoralRoll: {
        record: 'ElectoralRoll',
        noRecord: 'ElectoralRollNoRecord',
    },
    insolvencies: {
        bankruptcyOrSequestration: 'BankruptcyOrSequestration',
        administrationOrder: 'AdministrationOrder',
        debtReliefOrder: 'DebtReliefOrder',
        ivaTrustDeedOrFastTrackVoluntaryArrangement: 'IvaTrustDeedOrFastTrackVoluntaryArrangement',
    },
};
export const getDisputeUrl = () => Config.IS_PROD === 'true' ? TU_DISPUTE_URL_PROD : TU_DISPUTE_URL_STAGING;
export const accountDisputeFields = (account) => ({
    accountId: account.accountId,
    memberPortId: account.memberPortId,
    accountHolderId: account.accountHolderDetails?.accountHolderId,
});
export const searchDisputeFields = (search) => ({
    searchReference: search.searchReference,
});
export const addressLinkDisputeFields = (link) => ({
    addressLinkId: link.addressLinkId,
    addressLinkAddress: link.addressFrom || link.addressTo,
});
export const aliasDisputeFields = (alias) => ({
    aliasId: alias.aliasId,
});
export const associateDisputeFields = (connection) => ({
    associateId: connection.associateId,
});
export const judgmentDisputeFields = (judgment) => ({
    casePerId: judgment.casePerId,
});
export const electoralRollDisputeFields = (electoralRoll) => ({
    electoralRollId: electoralRoll?.electoralRollId,
});
export const insolvencyDisputeType = (insolvency) => {
    switch (insolvency.orderTypeCode) {
        case 'AO':
            return DisputeTypeEnum.insolvencies.administrationOrder;
        case 'DR':
            return DisputeTypeEnum.insolvencies.debtReliefOrder;
        case 'IV':
        case 'TD':
        case 'FT':
            return DisputeTypeEnum.insolvencies
                .ivaTrustDeedOrFastTrackVoluntaryArrangement;
        case 'BO':
        case 'ES':
        default:
            return DisputeTypeEnum.insolvencies.bankruptcyOrSequestration;
    }
};
export const insolvencyDisputeFields = (insolvency) => ({
    insolvencyOrderId: insolvency.insolvencyOrderId,
});
// Builds the HTML doc loaded into the in-app WebView. On mount the form
// auto-POSTs to TU and the user lands on TU's hosted dispute page.
// Field values are escaped so that report content with quotes or angle
// brackets can't break out of the attribute.
export const buildDisputeFormHtml = ({ url, fields, }) => {
    const escape = (value) => value
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    const inputs = Object.entries(fields)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([name, value]) => `<input type="hidden" name="${escape(name)}" value="${escape(String(value))}" />`)
        .join('');
    return `<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1" /></head><body><form id="f" method="post" action="${escape(url)}">${inputs}</form><script>document.getElementById('f').submit();</script></body></html>`;
};
